import { useTranslation } from 'react-i18next';
import Alert from './Alert';
import { useAlertStore } from './AlertStore';
import { useCallback } from 'react';

export const useNotify = () => {
  const { showAlert, hideAlert } = useAlertStore();
  const { t } = useTranslation();

  const notify = useCallback(
    (messageKey: string, onCloseCallback?: () => void) => {
      showAlert({
        content: (
          <Alert
            message={t(messageKey)}
            onClose={() => {
              hideAlert();
              if (onCloseCallback) onCloseCallback();
            }}
          />
        ),
      });
    },
    [showAlert, hideAlert, t]
  );

  return notify;
};
